export default function useSkipModules (route) {
  const skipModulesQuery = decodeURI(route?.query?.skipModules).split(',');
  enum moduleNames {
    AD = 'ad',
    ADOBE = 'adobe',
    ONETRUST = 'onetrust',
    AIMJS = 'aimjs',
    JOB = 'job',
  }

  const skipModule = (moduleName: string): boolean => {
    return skipModulesQuery.includes(moduleName);
  };

  return {
    moduleNames,
    skipModule
  };
}
